import styled from "styled-components";

import { websiteWorldWideOverviewLogic } from "app/pages/website-performance/helpers/websitePerformanceHelpers";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { TrafficAndEngagementHighLevelDataInner } from "../../TrafficAndEngagementHighLevelData";
import type { ITrafficWidgetsContainerProps } from "../../types";

import { DeviceDistributionWidget } from "./DeviceDistribution/DeviceDistributionWidget";
import { MonthlyActiveUsersWidget } from "./MonthlyActiveUsers/MonthlyActiveUsersWidget";
import { TotalVisitsPOPWidget } from "./TotalVisits/TotalVisitsPOPWidget";
import { WebsiteRankWidget } from "./WebsiteRank/WebsiteRankWidget";

const WidgetsGrid = styled.div`
    display: grid;
    gap: 24px;
    margin-bottom: 24px;
    width: 100%;

    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: 250px;

    & > * {
        min-width: 0;
    }
`;

export const TrafficSingleModePOPContainer = (props: ITrafficWidgetsContainerProps) => {
    const { showGAApprovedData, apiParams, isGAPrivate, params } = props;
    const { webSource, country } = apiParams;

    const { apiController } = websiteWorldWideOverviewLogic(country);

    const durationObject = DurationService.getDurationData(params.duration, params.comparedDuration);
    const dateRangeText = Array.isArray(durationObject.forWidget)
        ? durationObject.forWidget[0]
        : durationObject.forWidget;
    const countryText = CountryService.getCountryById(country)?.text ?? "";

    return (
        <div>
            <WidgetsGrid>
                <TotalVisitsPOPWidget
                    params={apiParams}
                    dateRangeText={dateRangeText}
                    countryText={countryText}
                    countryCode={country}
                    showGAApprovedData={showGAApprovedData}
                    isGAPrivate={isGAPrivate}
                />
                {webSource === devicesTypes.TOTAL ? (
                    <DeviceDistributionWidget
                        params={apiParams}
                        dateRangeText={dateRangeText}
                        countryText={countryText}
                        countryCode={country}
                        showGAApprovedData={showGAApprovedData}
                        isGAPrivate={isGAPrivate}
                        apiController={apiController}
                        showAddToDashboard={false}
                    />
                ) : (
                    <MonthlyActiveUsersWidget
                        params={apiParams}
                        showGAApprovedData={showGAApprovedData}
                        isGAPrivate={isGAPrivate}
                    />
                )}
                <WebsiteRankWidget
                    params={apiParams}
                    apiController={apiController}
                />
            </WidgetsGrid>
            <TrafficAndEngagementHighLevelDataInner {...props} />
        </div>
    );
};
